const API_BASE = process.env.REACT_APP_API_BASE || '/api';

async function request(path, opts = {}) {
  const url = API_BASE + path;
  console.log('[wishlist.js] Request:', url, opts.method || 'GET');
  const res = await fetch(url, { ...opts, credentials: 'include' });
  const text = await res.text();
  console.log('[wishlist.js] Response:', res.status, text.substring(0, 300));
  try { return JSON.parse(text); } catch (e) { return text; }
}

export async function addToWishlist({ productId, productLink, token }) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  const body = {};
  if (productId) body.productId = productId;
  else if (productLink) body.productLink = productLink;
  return request('/wishlist/add', { method: 'POST', headers, body: JSON.stringify(body) });
}

export async function getWishlist({ token }) {
  const headers = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  return request('/wishlist', { method: 'GET', headers });
}

export async function removeFromWishlist({ id, token }) {
  const headers = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  return request(`/wishlist/${id}`, { method: 'DELETE', headers });
}

// New helpers that include guestId when unauthenticated
export async function addToWishlistGuest({ productId, productLink, guestId }) {
  const headers = { 'Content-Type': 'application/json' };
  const body = { guestId };
  if (productId) body.productId = productId; else if (productLink) body.productLink = productLink;
  return request('/wishlist/add', { method: 'POST', headers, body: JSON.stringify(body) });
}

export async function getWishlistGuest({ guestId }) {
  return request(`/wishlist?guestId=${encodeURIComponent(guestId)}`, { method: 'GET' });
}

export async function removeFromWishlistGuest({ id, guestId }) {
  return request(`/wishlist/${id}?guestId=${encodeURIComponent(guestId)}`, { method: 'DELETE' });
}
